import React, { Component, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import dayjs from 'dayjs'

export default function GasgenUnit({ valueGasUsed }) {
  const [tickAmount, setTickAmount] = useState(valueGasUsed?.length)
  const [valueFormat, setValueFormat] = useState('DD MMM')
  //console.log('valueGasUsed', valueGasUsed)
  const series = [
    {
      name: 'ปริมาณแก๊สที่ใช้ผลิตไฟฟ้า',
      type: 'column',
      data: valueGasUsed,
      //data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160],
    },
  ]
  const options = {
    chart: {
      height: 350,
      type: 'line',
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
    },

    xaxis: {
      type: 'datetime',
      labels: {
        formatter: (value) => dayjs(value).locale('th').format(valueFormat),
      },
      tickAmount,
    },
    yaxis: [
      {
        title: {
          text: 'ปริมาณแก๊สที่ใช้ผลิตไฟฟ้า',
        },
      },
    ],
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  )
}
